import React from "react";
import Layout from "./Layout";

const Rebate = () => {
  return (
    <Layout>
      <div>
        <div className="row rebate-nav no-gutters pa-4">
          <div className="rebate-header-item my-3 col col-5 selected">
            <a
              href="/rebate"
              className="router-link-exact-active router-link-active"
              style={{
                "-webkit-text-decoration": "unset !important",
                "text-decoration": "unset !important",
              }}
            >
              <span>Rebate</span>
            </a>
          </div>
          <div className="rebate-header-item my-3 col col-5">
            <a
              href="/rebateHistory"
              className
              style={{
                "-webkit-text-decoration": "unset !important",
                "text-decoration": "unset !important",
              }}
            >
              <span>Rebate History</span>
            </a>
          </div>
        </div>
        <div className="mx-6 py-2 rebate-card v-card v-sheet theme--light">
          <div className="row">
            <div className="text-center rebate-card-title pb-1 col col-12">
              Total Pending Claim
            </div>
            <div className="mx-auto pa-0 col col-8">
              <div className="claim-amount v-card v-sheet theme--light">
                <v-text className="pa-3">৳ 0.00</v-text>
              </div>
            </div>
            <div className="pa-0 pb-1 text-center col col-12">
              <label className="rebate-card-desc">Last Updated - -</label>
            </div>
            <div className="text-center pa-0 col col-12">
              <button
                type="button"
                disabled="disabled"
                className="rebate-redeem-btn v-btn v-btn--disabled v-btn--has-bg theme--light v-size--default"
              >
                <span className="v-btn__content">Claim All</span>
              </button>
            </div>
            <div className="pa-0 pb-3 text-center col">
              <label className="rebate-card-desc">Last Claimed - -</label>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default Rebate;
